import React, { useEffect } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

const initializeLocalStorageWithObject = (data: Record<string, string>) => {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

const SsoLoginWrapper: React.FC = () => {
  useEffect(() => {
    const queryParam = new URLSearchParams(window.location.search);
    if (queryParam.get('data')) {
      initializeLocalStorageWithObject(JSON.parse(queryParam.get('data') || '{}'));
      const redirectPath = localStorage.getItem('redirect-path')
        ? localStorage.getItem('redirect-path')
        : '/';
      localStorage.removeItem('redirect-path');
      window.location.href = `${window.location.origin}${redirectPath}`;
    }
  }, []);

  const intl = useIntl();

  return (
    <div>{intl.formatMessage(messages.redirecting)}</div>
  );
};

export default SsoLoginWrapper;
